import { render } from "./PerformanceSentiment.vue?vue&type=template&id=aa90c9c8&scoped=true"
import script from "./PerformanceSentiment.vue?vue&type=script&lang=js"
export * from "./PerformanceSentiment.vue?vue&type=script&lang=js"

import "./PerformanceSentiment.vue?vue&type=style&index=0&id=aa90c9c8&lang=scss&scoped=true"
import "./PerformanceSentiment.vue?vue&type=style&index=1&id=aa90c9c8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa90c9c8"]])

export default __exports__